import styled, { css } from 'styled-components';
import { rgba } from 'polished';

// Import styles
import { flex, customMinResponsive, size } from 'components/styles';

export const Wrapper = styled.div<{ isRemoved: boolean }>`
	${flex({ jc: 'space-between' })}
	gap: 0.5rem;
	color: ${({ theme }) => theme.configurator.color.primary}
	font-size: 1.5rem;

	${({ theme, isRemoved }) =>
		isRemoved &&
		css`
			* {
				text-decoration: line-through;
				color: ${rgba(theme.configurator.color.primary, 0.7)} !important;
			}
		`}

	&:not(:first-child) {
		margin-top: 2rem;
	}

	${customMinResponsive(
		size.semi,
		css`
			font-size: 1.8rem;
		`
	)}
`;

export const Title = styled.p`
	max-width: 45%;
	font-weight: ${({ theme }) => theme.font.light};

	${customMinResponsive(
		size.xsmall,
		css`
			max-width: 55%;
		`
	)}
`;
